import React, { useState, useEffect, useContext, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import { AuthContext } from "../../../Header/auth - context";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import usePermission from "../../../custom/usePermission";
import useVisinaTabele from "../../../custom/visinaTabele";

const TIP_LABEL = { 381: "KO", 383: "KZ", 384: "PO" };

const ProveraDokumenataKOKZ = ({ setIdDokument, setKoKzView }) => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const toast = useRef(null);
  const userRole = useSelector((s) => s.user_role);
  const eskaliran = useSelector((s) => s.eskaliran);

  const [podaci, setPodaci] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [sefLoading, setSefLoading] = useState(false);
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([podaci]);

  const { can } = usePermission();
  const canAccess = can('FAKTURE', 'edit');

  useEffect(() => {
    if (!canAccess) return;
    fetch(process.env.REACT_APP_BACKEND_URL + "/invoice/KoKzGetPregled", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ provera: 1 }),
    })
      .then((r) => r.json())
      .then((data) => setPodaci(data || []))
      .catch(() => setPodaci([]));
  }, [canAccess]);

  const handleSefStatus = (row) => {
    if (!row?.id) return;
    setSefLoading(true);
    fetch(process.env.REACT_APP_BACKEND_URL + "/sef/GetKoKzStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id_dokument: row.id }),
    })
      .then((r) => r.json())
      .then((data) => {
        setPodaci((prev) =>
          prev.map((r) =>
            r.id === row.id ? { ...r, sefStatus: data.status, sefKomentar: data.komentar } : r
          )
        );
        toast.current.show({
          severity: "info",
          summary: `SEF status: ${data.status || "Nepoznat"}`,
          detail: data.komentar || "",
          life: 5000,
        });
      })
      .catch(() =>
        toast.current.show({ severity: "error", summary: "Greška pri proveri SEF statusa.", life: 3000 })
      )
      .finally(() => setSefLoading(false));
  };

  const tableHeader = (
    <div className="export-buttons fakture-stavke-header">
      <div className="fakture-stavke-radnje" />
      <input
        type="search"
        placeholder={t('nova.phPretraga')}
        className="p-inputtext p-component"
        onInput={(e) => setGlobalFilter(e.target.value)}
      />
    </div>
  );

  if (!canAccess) {
    return (
      <div className="col-12">
        <Card>
          <p>Nemate pristup ovoj sekciji.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable
            value={podaci || []}
            paginator
            rows={redovaTabele}
            globalFilter={globalFilter}
            scrollable
            scrollHeight={visinaTabele}
            header={tableHeader}
            resizableColumns
            columnResizeMode="expand"
            className="turePregledTable stavke-tabela"
          >
            <Column
              header={t('nova.otvori')}
              style={{ minWidth: 80 }}
              body={(rowData) => (
                <Button
                  label={t('nova.otvori')}
                  icon="pi pi-pencil"
                  type="button"
                  className="p-button-text p-button-sm"
                  onClick={() => {
                    const isDinarska = rowData.TipFakture === 305;
                    setIdDokument(rowData.id);
                    setKoKzView(isDinarska ? 1 : 2);
                  }}
                />
              )}
            />
            <Column
              field="TipDokumenta"
              header={t('nova.tip')}
              style={{ minWidth: 60 }}
              body={(r) => TIP_LABEL[r.TipDokumenta] || r.TipDokumenta}
            />
            <Column field="brojDokumenta" header={t('nova.brojDokumenta')} style={{ minWidth: 150 }} />
            <Column field="NazivKlijenta" header={t('nova.klijent')} style={{ minWidth: 200 }} />
            <Column field="Datum" header={t('nova.datum')} style={{ minWidth: 110 }} />
            <Column field="Valuta" header={t('nova.valuta')} style={{ minWidth: 80 }} />
            <Column
              field="sefStatus"
              header={t('nova.sefStatus')}
              style={{ minWidth: 110 }}
              body={(r) => (
                <span
                  style={{
                    padding: "2px 8px",
                    borderRadius: 4,
                    background:
                      r.sefStatus === "Approved"
                        ? "#d4edda"
                        : r.sefStatus === "Rejected"
                        ? "#f8d7da"
                        : r.sefStatus === "Sent"
                        ? "#fff3cd"
                        : "#e9ecef",
                    color:
                      r.sefStatus === "Approved"
                        ? "#155724"
                        : r.sefStatus === "Rejected"
                        ? "#721c24"
                        : r.sefStatus === "Sent"
                        ? "#856404"
                        : "#495057",
                    fontSize: "0.8rem",
                  }}
                >
                  {r.sefStatus || "–"}
                </span>
              )}
            />
            <Column
              header={t('nova.proveriSef')}
              style={{ minWidth: 110 }}
              body={(rowData) =>
                rowData.statusSefa && rowData.TipDokumenta !== 384 ? (
                  <Button
                    icon="pi pi-refresh"
                    type="button"
                    className="p-button-text p-button-sm"
                    disabled={sefLoading}
                    onClick={() => handleSefStatus(rowData)}
                    tooltip="Proveri SEF status"
                    tooltipOptions={{ position: "left" }}
                  />
                ) : null
              }
            />
            <Column field="sefKomentar" header={t('nova.sefKomentar')} style={{ minWidth: 180 }} />
          </DataTable>
      </div>
    </div>
  );
};

export default ProveraDokumenataKOKZ;
